import { Link } from "react-router-dom";

export default function Cancel() {
  return (
    <section className="min-h-[60vh] flex flex-col items-center justify-center px-6 py-12 text-center">
      <h1 className="text-3xl font-bold mb-4 text-red-500">❌ Paiement annulé</h1>
      <p className="text-gray-600 mb-6">
        Votre commande n’a pas été finalisée. Vous pouvez réessayer à tout moment.
      </p>
      <Link
        to="/cart"
        className="bg-black text-white px-6 py-2 rounded hover:bg-gray-800 transition"
      >
        Retour au panier
      </Link>
    </section>
  );
}
